// The three collection methods Prism stores in send_type, with the labels
// staff see. One list, read by the method picker and the change history.
export const COLLECTION_METHODS = [
  { value: 'courier', label: 'Courier collection' },
  { value: 'dropoff', label: 'Drop-off' },
  { value: 'warehouse_dropoff', label: 'Deliver in person' },
]

// Staff may switch only between these. Deliver in person needs a date and a
// slot, so it is booked through its own flow, and Prism refuses any switch
// away from it.
export const PICKABLE_METHODS = COLLECTION_METHODS.filter(m => m.value !== 'warehouse_dropoff')

export const METHOD_LOCKED_TEXT = 'A label is booked. Cancel the collection to change the method.'

export const WAREHOUSE_LOCKED_TEXT = 'A Deliver in person booking keeps its method. Cancel the collection to change it.'

export function methodLabel(value) {
  return COLLECTION_METHODS.find(m => m.value === value)?.label ?? value
}
